import React from "react"
import {SosAuthorType, SosPublicationSeriesItemType, SosPublicationType} from "../../types";


export interface Props {
    publication: SosPublicationType | SosPublicationSeriesItemType
}

function C039Author(props: Props) {
    const authorsList = props.publication.authors as [SosAuthorType] ?? props.publication.vitae as [SosAuthorType];
    let authors = ""
    authorsList?.map((author: SosAuthorType, index: number) => {
        if (author) {
            authors += author.name + " " + author.surname
            if (authorsList.length > index + 1) {
                authors += ", "
            }
        }
    })
    return <React.Fragment key={props.publication.id}>{authors}</React.Fragment>
}

export default C039Author